import { MetricDetails } from '../../../../../../api/metrics/types';
import { DomainPreferences } from '../../../../../../api/types';
import { MetricId } from '../../../../../../api/types-graphql';
import { DataFieldValueFormatter } from '../../../../../hooks';
import { ChartData } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-types';
import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import { getChartDataFromSegmentedResponse } from '../../../common/utils';
import {
  TimePeriodSegmentedVizData,
  TimePeriodSegmentedVizDataResponse,
  TimePeriodSegmentedVizExternalProps,
} from '../../types';
import {
  TimePeriodSegmentedBarChartActions,
  TimePeriodSegmentedBarChartState,
  TimePeriodSegmentedBarChartUiComponentProps,
} from './types';

const getChartDataFromTimePeriodSegmentedResponse = (
  response: TimePeriodSegmentedVizDataResponse,
  preferences: DomainPreferences,
  metricDetailsMap: Partial<Record<MetricId, MetricDetails>>,
  metricDisplayValues: Partial<Record<MetricId, string>>,
  dataFieldValueFormatter: DataFieldValueFormatter
): ChartData => {
  return getChartDataFromSegmentedResponse(
    {
      ...response,
      isSegmented: true,
    },
    preferences,
    metricDetailsMap,
    metricDisplayValues,
    dataFieldValueFormatter
  );
};

export const timePeriodSegmentedBarChartDataToUiComponentProps = (
  data: TimePeriodSegmentedVizData,
  externalProps: TimePeriodSegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    TimePeriodSegmentedBarChartState,
    TimePeriodSegmentedBarChartActions
  >,
  { dataFieldValueFormatter }: DataVizContainerCommonUtils
): TimePeriodSegmentedBarChartUiComponentProps => {
  const { fullScreenHandle, preferences } = externalProps;
  const { dataResponse, titleConfig, metricDetails, metricDisplayValues } =
    data;
  const chartData = getChartDataFromTimePeriodSegmentedResponse(
    dataResponse,
    preferences,
    metricDetails,
    metricDisplayValues,
    dataFieldValueFormatter
  );
  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };
  return {
    fullScreenHandle,
    displayConfig,
    titleConfig,
    chartData,
    chartColors: data.chartColors,
  };
};
